import React from 'react';
import {Modal, ModalHeader, ModalBody } from 'reactstrap';

const ContactModal = (props) => {
  const { toggleContactModal, isOpen } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggleContactModal} contentClassName="border-0"
            style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
      <ModalHeader toggle={toggleContactModal} style={{border: 'none'}}></ModalHeader>
      <ModalBody className="pb-5 pt-3">
        <div className="text-center">
          <h4 className="font-weight-bolder mb-3">info@klubiprodhuesve.org</h4>
          <h4 className="font-weight-bolder">+383 45 666 486</h4>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ContactModal;